import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys } from "vue"

const _hoisted_1 = { id: "professionalCareerObjectiveDetailTab" }
const _hoisted_2 = {
  key: 0,
  class: "ml-2 text-error"
}
const _hoisted_3 = {
  key: 1,
  class: "ml-2 text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_JobPreferencesItem = _resolveComponent("JobPreferencesItem")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_NumberField = _resolveComponent("NumberField")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _cache[16] || (_cache[16] = _createTextVNode(" Add Job Preferences ")),
            (_ctx.jobPreferences.length === 0)
              ? (_openBlock(), _createElementBlock("small", _hoisted_2, "*"))
              : _createCommentVNode("", true),
            (_ctx.jobPreferences.length === 0)
              ? (_openBlock(), _createElementBlock("small", _hoisted_3, "One Job Preference is required"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoBox, { title: "Tell us what your Job Preferences are, including your preferred roles, working arrangements and rates. This will help us match your profile with the roles that best suit your skills and needs." })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "primary_btn w-100",
                      "prepend-icon": "mdi-plus",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddJobPreferences = true))
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode(" Add Job Preferences")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-5" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPreferences, (item, index) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "12",
                    md: "6",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_JobPreferencesItem, {
                        jobPreferences: item,
                        jobTitles: _ctx.jobTitles,
                        loading: _ctx.loading,
                        isHiringmanager: _ctx.isHiringmanager,
                        onEdit: ($event: any) => (_ctx.edit(item, index)),
                        onRemove: ($event: any) => (_ctx.remove(item, index))
                      }, null, 8, ["jobPreferences", "jobTitles", "loading", "isHiringmanager", "onEdit", "onRemove"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      persistent: "",
      onKeydown: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.showAddJobPreferences = false), ["esc"])),
      modelValue: _ctx.showAddJobPreferences,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showAddJobPreferences) = $event)),
      "max-width": "1000px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode(" Add Job Preferences ")
              ])),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref: "frmMain",
                  "lazy-validation": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoBox, { title: "Tell us what your Job Preferences are, including your preferred roles, working arrangements and rates. This will help us match your profile with the roles that best suit your skills and needs." })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createElementVNode("span", { class: "f-body-1" }, "What Position Would You Like to Work In?", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              readonly: _ctx.isHiringmanager,
                              outlined: "",
                              items: _ctx.jobTitles,
                              "item-title": "Name",
                              "item-value": "id",
                              rules: [_ctx.validations.required, _ctx.validations.arrayMinLength(1)],
                              hint: "Your skills will be assessed based on the job interest you select.",
                              placeholder: "Position",
                              modelValue: _ctx.jobPreferencesModel.WorkingPosition,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.jobPreferencesModel.WorkingPosition) = $event)),
                              dense: ""
                            }, null, 8, ["readonly", "items", "rules", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              readonly: _ctx.isHiringmanager,
                              dense: "",
                              outlined: "",
                              items: _ctx.seniorityLevels,
                              rules: [_ctx.validations.required],
                              placeholder: "Seniority Level",
                              showRequired: "",
                              modelValue: _ctx.jobPreferencesModel.SeiorityLevel,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.jobPreferencesModel.SeiorityLevel) = $event))
                            }, null, 8, ["readonly", "items", "rules", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              placeholder: "Years of experience",
                              dense: "",
                              outlined: "",
                              items: _ctx.experienceYears,
                              rules: [_ctx.validations.required],
                              modelValue: _ctx.jobPreferencesModel.PositionExperienceYear,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.jobPreferencesModel.PositionExperienceYear) = $event))
                            }, null, 8, ["items", "rules", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("span", { class: "f-body-1" }, "What Type of Employment are you most interested in?", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              readonly: _ctx.isHiringmanager,
                              dense: "",
                              outlined: "",
                              items: _ctx.employmentTypes,
                              multiple: "",
                              "deletable-chips": "",
                              chips: "",
                              rules: [_ctx.validations.required, _ctx.validations.arrayMinLength(1)],
                              placeholder: "Type Of Employment",
                              modelValue: _ctx.jobPreferencesModel.EmploymentType,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.jobPreferencesModel.EmploymentType) = $event))
                            }, null, 8, ["readonly", "items", "rules", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              readonly: _ctx.isHiringmanager,
                              dense: "",
                              outlined: "",
                              items: _ctx.locationTypes,
                              placeholder: "On-Site/Remote",
                              modelValue: _ctx.jobPreferencesModel.PreferredLocation,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.jobPreferencesModel.PreferredLocation) = $event)),
                              multiple: "",
                              "deletable-chips": "",
                              chips: ""
                            }, null, 8, ["readonly", "items", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("span", { class: "f-body-1" }, "What is your salary expectation?", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NumberField, {
                              readonly: _ctx.isHiringmanager,
                              min: 0,
                              disabled: _ctx.jobPreferencesModel.IsNegotiable,
                              dense: "",
                              modelValue: _ctx.jobPreferencesModel.Amount,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.jobPreferencesModel.Amount) = $event)),
                              outlined: "",
                              placeholder: "Salary Expectation"
                            }, null, 8, ["readonly", "disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              readonly: _ctx.isHiringmanager,
                              disabled: "",
                              dense: "",
                              modelValue: _ctx.jobPreferencesModel.Currency,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.jobPreferencesModel.Currency) = $event)),
                              outlined: "",
                              placeholder: "Currency"
                            }, null, 8, ["readonly", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          lg: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              readonly: _ctx.isHiringmanager,
                              label: "Not Specified / Negotiable",
                              class: "negotiable",
                              modelValue: _ctx.jobPreferencesModel.IsNegotiable,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.jobPreferencesModel.IsNegotiable) = $event))
                            }, null, 8, ["readonly", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancel())),
                  class: "secondary_btn mr-5",
                  loading: _ctx.loading,
                  "prepend-icon": "mdi-cancel"
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode(" Cancel")
                  ])),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_v_btn, {
                  class: "primary_btn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitForm())),
                  loading: _ctx.loading,
                  "prepend-icon": "mdi-plus"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.jobPreferencesModel.Id == "" && _ctx.selectedItemIndexForEdit == null ? "Add Job Preference" : "Save Job Preference"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.showRemoveConfirm,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showRemoveConfirm) = $event)),
      onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.showRemoveConfirm = false), ["esc"])),
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          onConfirm: _ctx.confirmDelete,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showRemoveConfirm = false)),
          message: _ctx.confirmModel
        }, null, 8, ["onConfirm", "message"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}